var _style, _path, _path2, _polygon, _polygon2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSeperateAuxiliaryLights({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    width: "16.3px",
    height: "16.3px",
    viewBox: "0 0 16.3 16.3",
    style: {
      enableBackground: "new 0 0 16.3 16.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#FFFFFF;stroke-width:0.25;stroke-miterlimit:10;}\n\t.st1{fill:none;stroke:#FFFFFF;stroke-width:0.25;stroke-miterlimit:10;}\n")), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Seperate Auxiliary Lights") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M8.1,0.1c4.4,0,8,3.6,8,8s-3.6,8-8,8s-8-3.6-8-8c0-3.1,1.9-5.2,2.2-5.5C2.6,2.3,4.8,0.1,8.1,0.1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M13.6,5H2.7C2.5,5,2.3,4.8,2.3,4.6V2.9c0-0.2,0.1-0.3,0.3-0.3h10.9c0.2,0,0.3,0.1,0.3,0.3v1.7 C13.9,4.8,13.8,5,13.6,5z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "2.3,4.9 2.3,5.1 2.3,11 0.7,11 0.5,10.5 0.3,9.8 0.2,9.3 0.1,8.6 0.1,8 0.1,7.5 0.2,7 0.3,6.6 0.4,6  0.6,5.6 0.7,5.3 0.9,4.7 1.2,4.2 1.4,3.8 1.7,3.3 2.1,2.9 2.4,2.7 2.4,2.7 2.4,3.3 2.4,3.7 2.4,4 2.4,4.4 "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "14,4.9 14,5.1 14,11 15.7,11 15.8,10.5 16,9.8 16.1,9.3 16.2,8.6 16.2,8 16.2,7.5 16.1,7 16,6.6  15.9,6 15.7,5.6 15.6,5.3 15.4,4.7 15.1,4.2 14.9,3.8 14.6,3.3 14.3,2.9 13.9,2.6 13.9,2.7 13.9,3.3 13.9,3.7 13.9,4 13.9,4.4 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeperateAuxiliaryLights);
export default __webpack_public_path__ + "static/media/SeperateAuxiliaryLights.8df342baa31f1c4918457e1893de61eb.svg";
export { ForwardRef as ReactComponent };